// import FunifierWidget from "@/components/funifier/widget";
import { Card } from "@/components/ui/card";
import Title from "@/components/ui/title";
import { useAppStore } from "@/store/app";
import { useChallengesStore } from "@/store/challenges";
import { useCallback, useEffect } from "react";

export default function ChallengeList() {
  const { user } = useAppStore();
  const { challenges, getAll } = useChallengesStore();

  const getCompleteCount = useCallback(
    (challengeId: string) => {
      const count = (user?.challenges as any)[challengeId] || 0;
      return count;
    },
    [user],
  );

  const getChallengeProgress = useCallback(
    (challengeId: string) => {
      const progress: any = user?.challenge_progress?.find(
        (item: any) => item.challenge === challengeId,
      );

      if (progress?.percent_completed) {
        return (
          <div className="flex items-center gap-3">
            <progress
              className="flex-1"
              value={progress.percent_completed}
              max="100"
            />
            <p>
              {Math.round(progress.rules[0].times_completed)} /{" "}
              {Math.round(progress.rules[0].times_required)}
            </p>
          </div>
        );
      }
    },
    [user],
  );

  useEffect(() => {
    getAll();
  }, [getAll]);

  return (
    <div>
      <Title>Desafios</Title>
      {/* <div className="w-1/2 h-[60vh] mx-auto">
        <FunifierWidget id="ranking_angularjs" />
      </div> */}
      <div className="grid grid-cols-1 md:grid-cols-3 flex-col gap-4">
        {challenges?.map((challenge) => (
          <Card
            key={challenge._id}
            className="flex w-full items-center p-2 gap-4"
          >
            {challenge.badgeUrl ? (
              <div className="relative">
                <div className="bg-gray-100 w-14 aspect-square rounded-full overflow-hidden relative">
                  <img
                    src={challenge.badgeUrl}
                    alt={challenge.challenge}
                    className="w-full h-full  object-contain object-center"
                  />
                </div>
                {getCompleteCount(challenge._id) > 0 ? (
                  <div className="absolute -bottom-2 bg-blue-700 ring-white  ring-2 leading-none flex items-center justify-center text-xs text-white font-bold p-2 rounded-full">
                    {getCompleteCount(challenge._id)}x
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className="flex-1">
              <h1 className="leading-none">{challenge.challenge}</h1>
              <p>{challenge.description}</p>
              {getChallengeProgress(challenge._id)}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
